import _ from 'lodash';
import BaseStore from '../../../common/js/stores/BaseStore';
import Dispatcher from '../../../common/js/dispatcher/Dispatcher';
import { ActionTypes } from './actions';

class TireChangeStore extends BaseStore {
    constructor() {
        super();
        this._licenseNumber = null;
        this._selectedService = null;
        this._hotel = false;

        this._selectedShop = null;
        this._selectedSlot = null;

        this._shops = [];

        this._timeIsUp = false;

        this.bindActions(
            ActionTypes.SET_LICENSE_NUMBER, this.setLicenseNumber,
            ActionTypes.SET_SELECTED_SERVICE, this.setSelectedService,
            ActionTypes.SET_SELECTED_SLOT, this.setSelectedSlot,
            ActionTypes.SET_HOTEL, this.setHotel,

            ActionTypes.SET_SELECTED_SHOP, this.setSelectedShop,

            ActionTypes.SET_SHOPS, this.setShops,

            ActionTypes.SET_TIME_IS_UP, this.setTimeIsUp,
        )
    }
    getAll() {
        return {
            licenseNumber: this._licenseNumber,
            selectedService: this._selectedService,
            hotel: this._hotel,

            selectedShop: this._selectedShop,
            selectedSlot: this._selectedSlot,

            shops: this._shops,
            timeIsUp: this._timeIsUp,
        };
    }

    // Action handlers
    setLicenseNumber(action) {
        this._licenseNumber = action.payload;
    }
    setSelectedService(action) {
        this._selectedShop = null;
        this._selectedService = action.payload;
    }
    setHotel(action) {
        this._hotel = action.payload;
    }
    setSelectedShop(action) {
        this._selectedShop = action.payload;
    }
    setSelectedSlot(action) {
        this._selectedSlot = action.payload;
    }
    setShops(action) {
        this._shops = action.payload;
    }
    setTimeIsUp(action) {
        this._timeIsUp = action.payload;
    }
}

export default new TireChangeStore();


/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-change/tire-change-store.js
 **/